







































































import { Component, Vue, Prop } from 'vue-property-decorator';
import HelperOffset from '@/components/helper/Offset.vue';

@Component({
    inheritAttrs: false,
    components: {
        HelperOffset,
    }
})
export default class MaterialCard extends Vue {
    @Prop({ default: 'secondary' }) color?: string;
    @Prop({ default: 10 }) elevation?: number | string;
    @Prop({ default: false }) inline?: boolean;
    @Prop({ default: false }) fullWidth?: boolean;
    @Prop({ default: 24 }) offset?: number;
    @Prop() title?: string;
    @Prop() text?: string;
    @Prop() icon?: string;
    @Prop() button_icon?: string;

    get hasOffset() {
      return this.$slots.header ||
        this.$slots.offset ||
        this.title ||
        this.text
    }
    get styles () {
      if (!this.hasOffset || this.offset === undefined) return null

      return {
        marginBottom: `${this.offset}px`,
        marginTop: `${this.offset * 2}px`
      }
    }
}
